import { render } from "./NewFrame.vue?vue&type=template&id=6238f1f9"
import script from "./NewFrame.vue?vue&type=script&lang=js"
export * from "./NewFrame.vue?vue&type=script&lang=js"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__